import React, { useRef, useState } from 'react';
import TagManagerService from 'services/TagManager';
import WalletService from 'services/Wallet';
import NewRelicService from 'services/NewRelic';
import { walletPaymentsName } from "config";
import StorageService from 'services/StorageService';
import style from './style.scss'



const AddCardsContent = ({value, debit}) => {
    const [openTcenco, setOpenTcenco] = useState(false);
    const [errorBin, setErrorBin] = useState(false);
    const inputBin =  useRef();
    const oneClick = walletPaymentsName.oneClick;
    const catOneClick = walletPaymentsName.catOneClick;
    const debitOneClick = walletPaymentsName.debitOneClick;

    const addCardWallet = (type, bin = null) => {
        if(type === catOneClick && !bin) return false;

        NewRelicService.sendPageAction({
            action: 'addCard',
            payload: {
                status: 'init'
            }
        });

        WalletService.addWalletCard(type, bin).then(response => {
            if(response.results) {
                NewRelicService.sendPageAction({
                    action: 'addCard',
                    payload: {
                        status: 'redirect'
                    }
                });
                TagManagerService.interaction( "Transbank", 'Agregar', 'Tarjeta');
                StorageService.setSecureItem('open_drawer_prime', value);
                setErrorBin(false)
                window.location = response.results;
            }else {
                if(response.status === 400){
                    setErrorBin(true);
                }
            }
        });

    }

    return(
        <div className="add-cards-wrapper">
            <div className={"add-tcenco" + (openTcenco ? ' open' : '')} >
                <h4 className="add-card-prime-title">Tarjeta de Cencosud Scotiabank</h4>
                {!openTcenco && <button className="new-link add-card-prime" onClick={() => setOpenTcenco(!openTcenco)}> Guardar tarjeta </button>}
                <span className="add-card-message">Ingresa los primeros 6 números de tu tarjeta</span>
                <div className="add-cards-bin">
                    <input placeholder="Ejemplo: 123456" maxLength={6} className={"add-cards-input-tcenco" + (errorBin ? ' error' : '')} onBlur={()=> setErrorBin(false)}ref={inputBin}/>
                    <button className="add-cards-tcenco" onClick={() => addCardWallet(catOneClick, inputBin?.current?.value)}> Agregar </button>
                </div>
            </div>
            <div className="add-wallet" onClick={() => setOpenTcenco(false)}>
                <h4 className="add-card-prime-title">Tarjeta de crédito</h4>
                <button className="new-link add-card-prime" onClick={() => addCardWallet(oneClick)}> Guardar tarjeta </button>
            </div>
            {debit && <div className="add-wallet" onClick={() => setOpenTcenco(false)}>
                <h4 className="add-card-prime-title">Tarjeta de dédito</h4>
                <button className="new-link add-card-prime" onClick={() => addCardWallet(debitOneClick)}> Guardar tarjeta </button>
            </div>}
        </div>
    )
}

export default AddCardsContent;